import { CommonSearchParam, ApiBind } from './common-search-param.model';

export class DealSearchParam extends CommonSearchParam {

  constructor(
    name?: string,
    outerDealId?: string
  ) {
    super();
    this.name = name;
    this.outer_deal_id = outerDealId;
  }

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'outer_deal_id' })
  outer_deal_id: string;

}
